import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "progress progress-reading p-fixed top-0 w-100 left-0" }

import { onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProgressReading',
  setup(__props) {


const progress = ref(0);
const updateScrollProgress = () => {
  const pixels = document.documentElement.scrollTop;
  const bodyElement = document.body;
  const htmlElement = document.documentElement;
  const height = Math.max(
    htmlElement.clientHeight, htmlElement.scrollHeight, htmlElement.offsetHeight,
    bodyElement.scrollHeight, bodyElement.offsetHeight
  );
  const pageHeight = height - window.screen.height;

  progress.value = Math.round(100 * pixels / pageHeight);

}

onMounted(()=>{
  window.addEventListener('scroll', updateScrollProgress);
  window.addEventListener('resize', updateScrollProgress);
  updateScrollProgress();
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "progress-bar border-radius-0 bg-color-primary",
      role: "progressbar",
      style: _normalizeStyle({width: progress.value + '%'})
    }, null, 4)
  ]))
}
}

})